import React from 'react'
import { FormFieldProps } from './types'
import styles from './Form.module.css'

export default function TextInput({
    fieldLabelClassName = styles.fieldLabel,
    requiredLabelClassName = styles.requiredLabel,
    title,
    inputType,
    inputName,
    placeholder,
    className,
    value,
    onChange,
}: FormFieldProps) {
    return (
        <>
            <dt className={fieldLabelClassName}>
                <span className={requiredLabelClassName}>必須</span>
                {title}
            </dt>
            <dd>
                <input
                    type={inputType}
                    name={inputName}
                    placeholder={placeholder}
                    className={className}
                    value={value}
                    onChange={onChange}
                    required
                />
            </dd>
        </>
    )
}
